module.exports = __webpack_public_path__ + "static/media/last-element.f1c8a2a5.svg";